import { render, staticRenderFns } from "./JobsLaborsTable.vue?vue&type=template&id=6c22200f&"
import script from "./JobsLaborsTable.vue?vue&type=script&lang=js&"
export * from "./JobsLaborsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports